export default __webpack_public_path__ + "static/media/rampver-bg-lines.3fd05c9f.png";